import { Dialog } from '@material-ui/core';
import { useModuleAssessmentStore } from './ModuleAssessment.store';
import {
  useModuleAssessmentQuestionsQuery,
  useModuleAssessmentReviewQuery,
} from './ModuleAssessment.queries';
import MultipleChoiceFeedback from '../common/MultipleChoiceFeedback';
import FeedbackQuestionTitle from '../common/FeedbackQuestionTitle';
import FeedbackAssessmentTitle from 'features/training/components/FeedbackAssessmentTitle';
import classes from './ModuleAssessmentResults.module.css';
import styles from 'assets/styles/training.module.scss';
import Organization from 'infrastructure/Organization';
import Loading from 'shared_ui_components/Loading';
import { useSalesRepView } from 'features/salesRepView/SalesRepView.hook';
import { useGetFF } from '@fstack-tech/ff_react_module';
import stylesTraining from '../../../training/components/Training.module.scss'
const ModuleAssessmentResults = () => {
  const {
    setModuleIdToViewResults,
    moduleIdToViewResults,
    setModuleName,
    moduleName,
    moduleToReviewUserUuid,
  } = useModuleAssessmentStore();

  const onClose = () => {
    setModuleIdToViewResults('');
    setModuleName('');
  };

  // Get the answers for the rep
  const { data: repData, isLoading: loadingRep = false } = useModuleAssessmentQuestionsQuery({
    module_uuid: moduleIdToViewResults,
  });

  // Get the questions for the admin, includes data of the rep
  const { data: adminData, isLoading: loadingAdmin = false } = useModuleAssessmentReviewQuery({
    module_uuid: moduleIdToViewResults,
    user_uuid: moduleToReviewUserUuid,
  });

  const { isActive } = useSalesRepView();
  const isRep = Organization?.isRep() || isActive;
  const questions = isRep ? repData : adminData?.assessment;
  const moduleTitle = moduleName || adminData?.training_module?.title || '';
  const { isEnabled: ff_group_by_topic } = useGetFF({ flag_id: 'group_by_topic' });
  const { isEnabled: ff_learningPaths } = useGetFF({ flag_id: 'learning_paths' });

  return (
    <Dialog
      fullWidth
      maxWidth="lg"
      onClose={onClose}
      open={Boolean(moduleIdToViewResults)}
      className={`dialog ${styles.assesmenteditDialog}`}
    >
      <FeedbackAssessmentTitle
        title={`${moduleTitle} - ${ff_learningPaths ? 'Skill Path Assessment' : 'Module Assessment'}`}
        handleClose={onClose}
        userAssessment={adminData}
        showScore={isRep ? !loadingRep : !loadingAdmin}
        score={adminData?.rating_percentage}
        score_status={adminData?.assessment_status}
      />
      {(isRep ? loadingRep : loadingAdmin) ? (
        <Loading loading circular margin={32} width="100%" />
      ) : (
        questions
          ?.filter((q) => q?.answer_type === 9 && Boolean(q?.answer?.id)) // Only show multiple choice questions
          ?.map((question, i) => (
            <div className={classes.answer}>
              {ff_group_by_topic && (
                <div>
                  {question?.topic_name !== null &&
                    question?.topic_name !== questions[i - 1]?.topic_name && (
                      <div
                        className={`${stylesTraining.headerTopic}`}
                      >
                        {question?.topic_name}
                      </div>
                    )}
                </div>
              )}
              <FeedbackQuestionTitle index={i} item={question} />
              <MultipleChoiceFeedback
                key={question?.id}
                question={question}
                hideCorrectAnswer={isRep}
              />
            </div>
          ))
      )}
    </Dialog>
  );
};

export default ModuleAssessmentResults;
